export default function AnnouncementBar() {
  const items = [
    "FREE U.S. SHIPPING OVER $200",
    "VERIFIED CERTIFICATES 7X TESTED",
    "FOR RESEARCH USE ONLY",
  ];
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className="overflow-hidden text-white" style={{ background: "linear-gradient(90deg, #c59b27 0%, #b3891d 50%, #a47d15 100%)" }} data-testid="announcement-bar">
      <div className="marquee py-2.5">
        {row.map((t, i) => (
          <span key={i} className="flex items-center text-[11px] font-semibold tracking-[0.18em] uppercase">
            <span className="px-6">{t}</span>
            <span style={{ color: "rgba(255,255,255,0.65)" }}>•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
